import {isSupportBrowser} from "~/utils/brower_check"

// 声明一个变量来存储动态加载的PDF模块
let PDF: any = null;
let TextLayerBuilder: any = null;


interface PDFDocumentInfo {
    _pdf: any,
    _totalPage: number,
}
// 缓存信息
export const analyzePdfMap = {

};

class PdfUtils {
    static CMAP_URL = "/cmaps/"
    static isLoaded = false;

    // 添加一个方法来动态加载PDF.js
    static async loadPdfJS() {
        if (this.isLoaded) return;
        console.log("loadPdfJS")
        try {
            // 动态导入PDF.js模块
            const pdfjs = await import('pdfjs-dist');
            PDF = pdfjs;

            // 动态导入worker
            // await import('pdfjs-dist/build/pdf.worker.entry.js');

            // 动态导入TextLayerBuilder
            const { TextLayerBuilder: TLB } = await import("pdfjs-dist/web/pdf_viewer");
            TextLayerBuilder = TLB;

            // 设置worker路径
            PDF.GlobalWorkerOptions.workerSrc = "/pdf.worker.js"//window.pdfjsWorker;

            this.isLoaded = true;
            console.log("PDF.js loaded successfully", PDF.version);
        } catch (error) {
            console.error("Failed to load PDF.js:", error);
            // 弹出提示：网络或者浏览器版本过低
            const { $i18n } = useNuxtApp()
            const t = $i18n.global.t
            throw new Error(t('browser-low-tip'));
        }
    }
    
    static async decodeBase64ToUint8Array(base64: string): Promise<Uint8Array> {
        // 检查输入是否为字符串
        if (typeof base64 !== 'string') {
            throw new Error('Input must be a string');
        }

        // 后续处理逻辑
        base64 = base64.replace(/-/g, '+').replace(/_/g, '/').replace(/[^A-Za-z0-9+/]/g, '');
        const padLength = (4 - (base64.length % 4)) % 4;
        base64 += '='.repeat(padLength);

        try {
            // 尝试解码
            const binaryString = atob(base64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        } catch (error) {
            console.error('Base64解码错误:', error);
            // 如果解码失败，返回一个空的Uint8Array
            return new Uint8Array();
        }
    }
    static async getPdfDocument(files){
        
        // 确保PDF.js已加载
        await this.loadPdfJS();
        // 判断缓存中是否存在当前的pdf文件; 存在直接返回
        return await Promise.all(files.map(file=> this.getSinglePdfDocument(file)))
    }

    static async getSinglePdfDocument(file,type?:any) : Promise<PDFDocumentInfo>{
        // 确保PDF.js已加载
        await this.loadPdfJS();
        // 判断缓存中是否存在当前的pdf文件; 存在直接返回
        
        

        // 健壮化处理，如果文件是base64格式，则先解码，暂时忽略
        // let stringNew = await this.decodeBase64ToUint8Array(string)
        // let pdfDocumentInfo = await PDF.getDocument({data:atob(string), cMapUrl: PdfUtils.CMAP_URL, cMapPacked: true}).promise
        // 这种使用新的方式 ArrayBuffer ，拿到处理的result， 可直接传进来
        let pdfDocumentInfo ;
        // 这里增加兼容处理， 如果是翻译上传页面，走兼容大文件方式。其他走正常的base64处理
        if(type === 'translate'){
            pdfDocumentInfo = await PDF.getDocument({data:file, cMapUrl: PdfUtils.CMAP_URL, cMapPacked: true}).promise
        }else{
            let arr = file.result.split("base64,");
            let string = arr[1]
            pdfDocumentInfo = await PDF.getDocument({data:atob(string), cMapUrl: PdfUtils.CMAP_URL, cMapPacked: true}).promise
        }
        return {
            _pdf: pdfDocumentInfo,
            _totalPage: pdfDocumentInfo._pdfInfo.numPages,
        }
    }

    static async getSingleBase64PdfDocument(fileBase64) : Promise<PDFDocumentInfo>{
        // 确保PDF.js已加载
        await this.loadPdfJS();
        // 判断缓存中是否存在当前的pdf文件; 存在直接返回

        let arr = fileBase64.split("base64,");
        let string = arr[1]
        // let stringNew = await this.decodeBase64ToUint8Array(string)
        let pdfDocumentInfo = await PDF.getDocument({data:atob(string), cMapUrl: PdfUtils.CMAP_URL, cMapPacked: true}).promise
        return {
            _pdf: pdfDocumentInfo,
            _totalPage: pdfDocumentInfo._pdfInfo.numPages
        }
    }

    static async getSingleURLPdfDocument(fileURL) : Promise<PDFDocumentInfo>{
        // 确保PDF.js已加载
        await this.loadPdfJS();
        // 判断缓存中是否存在当前的pdf文件; 存在直接返回

        let pdfDocumentInfo = await PDF.getDocument({url: fileURL, cMapUrl: PdfUtils.CMAP_URL, cMapPacked: true}).promise
        return {
            _pdf: pdfDocumentInfo,
            _totalPage: pdfDocumentInfo._pdfInfo.numPages
        }
    }
    static async getPdfPageRotation(page) {
     // 获取页面的旋转角度
     return page.rotate || 0;
   }
    // 被解析后的pdf对象信息
    static async getPdfPageInfo(pdf : PDFDocumentInfo){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        let pageMap = {};
        if (pdf && pdf._totalPage) {
            for (let i = 1; i <= pdf._totalPage; i++){
                // @ts-ignore
                pageMap[i] = await pdf._pdf.getPage(i);
            }
        }
        return pageMap
    }

    static async getPdfPageTextContent(pdf : PDFDocumentInfo){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        let pageMap = {};
        for (let i = 1; i <= pdf._totalPage; i++){
            // @ts-ignore
            let page = await pdf._pdf.getPage(i)
            pageMap[i] = await page.getTextContent()
        }
        return pageMap
    }


    // 获取PDF元数据
    static async getPdfMetaData(pdf : PDFDocumentInfo){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        let metaInfo = {};
        // 修复类型错误，使用any类型
        await (pdf._pdf as any).getMetadata().then((info: any)=>{
            metaInfo = info.info
        })
        return metaInfo
    }
    /**
     * 把pdf的某一页渲染至canvas
     * @param page
     * @param parent HTMLElement
     * @options 渲染的样式
     */
    static async renderPageToCanvas(page, parent, option : {scale?: number, width: number, height?: number}, callback?: (scale: number, height: number) => void, canvasName?:string){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        let canvas;
        if (canvasName && document.getElementById(canvasName)) {
            canvas = document.getElementById(canvasName)
        }else {
            canvas = document.createElement('canvas')
            if (canvasName) {
                canvas.setAttribute("id", canvasName)
            }
        }
        canvas.width = option.width;
        let context = canvas.getContext('2d');
        PdfUtils.initViewData(context)
        const [x1, , x2] = page._pageInfo.view;
        const pageWidth = x2 - x1;
        const myScale = option.width / pageWidth
        const pageRotation = await this.getPdfPageRotation(page);
        let viewport = page.getViewport({scale: myScale * 2, rotation: pageRotation});
        // let viewport = page.getViewport({scale: myScale * 2});
        // canvas.width = viewport.width * PdfUtils.pixelRatio;
        // canvas.height = viewport.height * PdfUtils.pixelRatio;
        // 根据旋转角度调整canvas尺寸
        if (pageRotation === 90 || pageRotation === 270) {
            // 交换宽度和高度
            canvas.width = viewport.height * PdfUtils.pixelRatio;
            canvas.height = viewport.width * PdfUtils.pixelRatio;
        } else {
            canvas.width = viewport.width * PdfUtils.pixelRatio;
            canvas.height = viewport.height * PdfUtils.pixelRatio;
        }

        canvas.style.width = option.width + 'px';
        // canvas.style.height = viewport.height + 'px'
        console.log('PdfUtils.transform', PdfUtils.transform, viewport)
        if (pageRotation === 90 || pageRotation === 270) {
            PdfUtils.transform = [
                PdfUtils.pixelRatio * Math.cos(pageRotation * Math.PI / 180),
                PdfUtils.pixelRatio * Math.sin(pageRotation * Math.PI / 180),
                -PdfUtils.pixelRatio * Math.sin(pageRotation * Math.PI / 180),
                PdfUtils.pixelRatio * Math.cos(pageRotation * Math.PI / 180),
                0, 0
              ];
        }
        let renderContext = {
            canvasContext: context,
            viewport: viewport,
            transform: PdfUtils.transform
        };
        page.render(renderContext);
        parent.appendChild(canvas)

        if (callback) {
            callback(myScale, canvas.height)
        }
    }

    static async renderPageToInfo(page, parent, option : {scale?: number, width: number, height?: number}, callback?: (scale: number, height: number) => void, canvasName?:string){
        // 确保PDF.js已加载
        await this.loadPdfJS();
        const [x1, , x2] = page._pageInfo.view;
        let pageWidth = x2 - x1;
        let myScale = option.scale ? option.width * option.scale / pageWidth : option.width / pageWidth
        // 获取页面旋转角度，并添加异常处理
        
        let viewport = page.getViewport({scale: myScale, rotation: page.rotate});
        // console.log("asadadad 4444=== 22 ", viewport, option, pageWidth)
        if ((viewport.rotation + 360) % 90 === 0 && (viewport.rotation + 360) % 180 !== 0) {
            pageWidth = page._pageInfo.view[3] - page._pageInfo.view[1]
            myScale = option.width / pageWidth * (option.scale || 1)
            viewport = page.getViewport({scale: myScale, rotation: page.rotate});
        }
        // 根据旋转角度调整高度计算
        let height = viewport.height;
        
        if (callback) {
            callback(myScale, height)
        }
    }
    static async renderPageToInfo1(page, parent, option : {scale?: number, width: number, height?: number}, callback?: (scale: number, height: number) => void, canvasName?:string){
        // 确保PDF.js已加载
        await this.loadPdfJS();
        const [x1, , x2] = page._pageInfo.view;
        const pageWidth = x2 - x1;
        const myScale = option.scale ? option.width * option.scale / pageWidth : option.width / pageWidth
        // 获取页面旋转角度，并添加异常处理
        let pageRotation: number;
        try {
            pageRotation = await this.getPdfPageRotation(page);
        } catch (error) {
            console.error('获取页面旋转角度失败:', error);
            pageRotation = 0; // 默认值为0
        }
        let viewport = page.getViewport({scale: myScale, rotation: pageRotation});
        // 根据旋转角度调整高度计算
        let height = viewport.height;
        if (pageRotation === 90 || pageRotation === 270) {
            height = viewport.width;
        }
        if (callback) {
            callback(myScale, height)
        }
    }

    static isInitData = false
    static pixelRatio = 1
    static transform
    static async initViewData(context){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        console.log("PDF version", PDF.version)
        if (PdfUtils.isInitData) return
        PdfUtils.isInitData = false
        let devicePixelRatio = window.devicePixelRatio || 1;
        let backingStoreRatio =
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1
        PdfUtils.pixelRatio = devicePixelRatio / backingStoreRatio;
        if (PdfUtils.pixelRatio !== 1) PdfUtils.transform = [PdfUtils.pixelRatio, 0, 0, PdfUtils.pixelRatio, 0, 0]
    }

    static async renderPageByCanvas(page, canvas, option : {scale?: number, width?: string, height?: string}){
        // 确保PDF.js已加载
        await this.loadPdfJS();

        // 获取页面旋转角度
        
        let context = canvas.getContext('2d');
        let viewport = page.getViewport({scale: option.scale});
        canvas.height = viewport.height;
        canvas.width = viewport.width;
       
        let renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        page.render(renderContext);
    }

    static async readFile(files){
        return await Promise.all(files.map(file=> this.readSingleFile(file)))
    }

    static async readSingleFile(file, callback?){
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await new Promise((resolve, reject)=> {
            reader.onload = resolve;
            reader.onerror = reject
        })
        
        return {
            result: reader.result,
            name: file.name,
            type: file.type,
            size: file.size,
            key: '', // 同一个文件的唯一key
        };
    }
    static async readSingleFile1(file, callback?): Promise<{ result: ArrayBuffer; name: string; type: string; size: number; key: string }> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

       
        // 文件加载成功时的回调
        reader.onload = (event) => {
            console.log("event.target.result", event?.target)
            if (event.target && event.target.result) {
                const arrayBuffer = event.target.result as ArrayBuffer;
                resolve({
                    result: arrayBuffer,
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    key: '', // 同一个文件的唯一key
                });
            } else {
                reject(new Error('Failed to load file: Result is undefined'));
            }
        };

        // 文件加载失败时的回调
        reader.onerror = () => {
            reject(new Error('An error occurred while reading the file'));
        };

        // 开始读取文件
        reader.readAsArrayBuffer(file);
        // reader.readAsDataURL(file);
    });
}

    static async getTextLayerBuilder() {
        // 确保PDF.js已加载
        await this.loadPdfJS();
        console.log("getTextLayerBuilder", TextLayerBuilder)
        return new TextLayerBuilder({})
    }
    static async getPDF() {
        await this.loadPdfJS();
        return PDF
    }
}

export default defineNuxtPlugin(nuxtApp =>{
    console.log("nuxtapp", nuxtApp)
    nuxtApp.$PdfUtils = PdfUtils
    const isSupport = isSupportBrowser()
    // 获取当前路由是否是提示升级的路由，不是的话则跳转到提示升级的路由
    const route = useRoute()
    if (!isSupport && !route.fullPath.includes('/browserUpgrade')) {
        navigateTo('/browserUpgrade')
    }
})
